module.exports = __webpack_public_path__ + "media/images/flavours/icon-fruit-blanc-et-jaune_dark-68caf1ef7b8fa7f38fb07f065e5bd9d7.png";